/* ============================================================
   D&V Market — Autocompletado de dirección con Google en el formulario EasySell
   Réplica del de Saluha (store.js:1012-1066), adaptada a Guatemala:
   - Mientras el cliente escribe la dirección (#es-address), muestra
     sugerencias de Google Places (API nueva), solo de Guatemala.
   - Al elegir una, completa la dirección y selecciona el Departamento
     (#es-province) y la Ciudad/Municipio (#es-city) del formulario.
   - Solo se activa si en el tema hay una clave de Google Maps
     (Configuración del tema → Dirección con Google). Sin clave, no hace nada.
   - Google cobra por sesión de autocompletado; la sesión se cierra al elegir.
   ============================================================ */
(function () {
  'use strict';
  var KEY = (window.DV_GMAPS_KEY || '').trim();
  if (!KEY) return;

  var places = null, token = null, cargando = null;

  function sinAcentos(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/^departamento de /, '').replace(/^municipio de /, '').trim();
  }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function cargarGoogle() {
    if (cargando) return cargando;
    cargando = new Promise(function (ok, fallo) {
      window.__dvGmapsListo = function () { ok(); };
      window.gm_authFailure = function () { fallo(new Error('clave de Google no autorizada')); };
      var s = document.createElement('script');
      s.async = true;
      s.onerror = fallo;
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(KEY) +
        '&libraries=places&callback=__dvGmapsListo&region=GT&language=es&loading=async';
      document.head.appendChild(s);
    }).then(function () { return google.maps.importLibrary('places'); })
      .then(function (lib) { places = lib; return lib; });
    return cargando;
  }

  // Elige en un <select> la opción cuyo texto coincide (sin acentos) y avisa a EasySell.
  function elegirOpcion(select, nombre) {
    if (!select || !nombre) return false;
    var buscado = sinAcentos(nombre);
    var opts = Array.prototype.slice.call(select.options);
    var op = opts.find(function (o) { return sinAcentos(o.text) === buscado; }) ||
             opts.find(function (o) { var t = sinAcentos(o.text); return t && (t.indexOf(buscado) === 0 || buscado.indexOf(t) === 0); });
    if (!op) return false;
    select.value = op.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function esperarOpciones(select, intentos) {
    return new Promise(function (ok) {
      (function revisar(n) {
        if (select.options.length > 1 || n <= 0) return ok();
        setTimeout(function () { revisar(n - 1); }, 150);
      })(intentos || 20);
    });
  }
  function componente(comps, tipo) {
    var c = (comps || []).find(function (x) { return (x.types || []).indexOf(tipo) >= 0; });
    return c ? (c.longText || c.long_name || c.shortText || '') : '';
  }

  function prepararCampo(inp) {
    if (inp.dataset.dvGoogle) return;
    inp.dataset.dvGoogle = '1';
    inp.setAttribute('autocomplete', 'off');
    var cont = inp.closest('.es-input-group') || inp.parentNode;
    cont.style.position = 'relative';
    var caja = document.createElement('div');
    caja.className = 'dv-sugerencias';
    caja.hidden = true;
    cont.parentNode.insertBefore(caja, cont.nextSibling);

    var silenciar = false;
    var buscar = debounce(function () {
      var q = inp.value.trim();
      if (q.length < 4) { caja.hidden = true; caja.innerHTML = ''; return; }
      cargarGoogle().then(function () {
        if (!token) token = new places.AutocompleteSessionToken();
        return places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: q, sessionToken: token, includedRegionCodes: ['gt'], language: 'es', region: 'gt'
        });
      }).then(function (r) {
        var preds = ((r && r.suggestions) || []).filter(function (s) { return s.placePrediction; }).slice(0, 5);
        if (!preds.length) { caja.hidden = true; caja.innerHTML = ''; return; }
        caja.innerHTML = preds.map(function (s, i) {
          return '<div class="dv-sugerencias__item" data-i="' + i + '">' + esc(s.placePrediction.text.text) + '</div>';
        }).join('');
        caja.hidden = false;
        Array.prototype.forEach.call(caja.querySelectorAll('.dv-sugerencias__item'), function (el) {
          el.addEventListener('mousedown', function (ev) { ev.preventDefault(); elegir(preds[+el.dataset.i]); });
        });
      }).catch(function () { caja.hidden = true; });
    }, 280);

    function elegir(pred) {
      caja.hidden = true; caja.innerHTML = '';
      // Se usa el texto de la sugerencia: trae la ZONA ("6A Avenida, Zona 1, …"),
      // que la dirección formateada de Google a veces omite. Sin segmentos repetidos.
      var vistos = {};
      var texto = pred.placePrediction.text.text.split(',').map(function (s) { return s.trim(); })
        .filter(function (s) { var k = s.toLowerCase(); if (!s || vistos[k] || k === 'guatemala') return false; vistos[k] = 1; return true; })
        .join(', ');
      silenciar = true;  // el valor lo pone el script: no volver a buscar sugerencias
      inp.value = texto;
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      silenciar = false;
      var lugar = pred.placePrediction.toPlace();
      lugar.fetchFields({ fields: ['addressComponents'] }).then(function () {
        var comps = lugar.addressComponents || [];
        var depto = componente(comps, 'administrative_area_level_1');
        var muni = componente(comps, 'administrative_area_level_2') || componente(comps, 'locality');
        var selDepto = document.getElementById('es-province');
        var selMuni = document.getElementById('es-city');
        if (selDepto && elegirOpcion(selDepto, depto) && selMuni) {
          esperarOpciones(selMuni).then(function () { elegirOpcion(selMuni, muni); });
        }
      }).catch(function () {}).then(function () { token = null; });
    }

    inp.addEventListener('input', function () { if (!silenciar) buscar(); });
    inp.addEventListener('blur', function () { setTimeout(function () { caja.hidden = true; }, 180); });
  }

  // EasySell arma el formulario después de cargar la página: lo vigilamos.
  var estilo = document.createElement('style');
  estilo.textContent =
    '#easysell .dv-sugerencias{background:#fff;border:1px solid #E1E7F0;border-radius:12px;box-shadow:0 10px 24px rgba(0,43,128,.14);margin-top:6px;max-height:240px;overflow:auto;position:relative;z-index:5}' +
    '#easysell .dv-sugerencias[hidden]{display:none}' +
    '#easysell .dv-sugerencias__item{padding:11px 14px;font-size:14px;line-height:1.35;color:#1A1A1A;cursor:pointer;border-bottom:1px solid #EEF2F8}' +
    '#easysell .dv-sugerencias__item:last-child{border-bottom:0}' +
    '#easysell .dv-sugerencias__item:hover{background:#EAF3FF}';
  document.head.appendChild(estilo);

  function revisar() { var inp = document.getElementById('es-address'); if (inp) prepararCampo(inp); }
  new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true });
  revisar();
})();
